import React, { useState } from "react";
import "./styles.css";
import Button from "../Button";
import LogoHeader from "../LogoHeader";

const statusData = {
  CLOSED: {
    title: "Session Left",
    message: "You have successfully left the session."
  },
  CLOSED_BY_ADMIN: {
    title: "Session Ended by Host",
    message: "The session host has ended the session."
  },
  SESSION_TIMEOUT: {
    title: "Session Timed Out",
    message: "The session has timed out."
  },
  CONNECTION_LOST: {
    title: "Connection Lost",
    message: "Your connection to the session was interrupted. Please check your internet connection, attempting to reconnect..."
  },
  SIMULATION_ERROR: {
    title: "Simulation Error",
    message: "Something went wrong with the simulation."
  },
  MINIMIZING_ERROR: {
    title: "Minimizing Error",
    message: "Something went wrong while trying to minimize."
  },
  GENERIC_ERROR: {
    title: "Something Went Wrong.",
    message: "An error occurred. Please try again."
  }
};

const AppModal = ({ status, message }) => {
  return (
    <div className="app-modal">
      <div className="app-modal-top-section column">
        <LogoHeader variant="dark" />
      </div>
      <div className="app-modal-bottom-section column">
        <div>
          <p className="reason-title">
            {status === "SIMULATION_ERROR" ? message : (statusData[status]?.title || "An error occurred.")}
          </p>
          <p className="reason-description">
            {status === "SIMULATION_ERROR" ? message : (statusData[status]?.message || "An error occurred.")}
          </p>
        </div>
        <div>
          <p className="modal-msg">We appreciate you using MolecularWebXR! Please share your experience, or return to the Home for another session.</p>
        </div>
        <div className="app-modal-btn-row row">
          <Button
            handleClick={() => {
              window.location.reload();
            }}
          >
            Home
          </Button>
          <Button
            handleClick={() => {
              window.open(
                "https://docs.google.com/forms/d/e/1FAIpQLSfAei42sNg8D0mNJ_SVcnZztxcI-GbEoSxEiCz_zCb9RvKgUA/viewform",
                "_blank"
              );
            }}
          >
            Feedback
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AppModal;
